import React from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { Form, Alert } from 'react-bootstrap';
import { Checkbox } from '../../common/components/formControls';

const SettingsForm = ({ error, handleSubmit, pristine, submitSucceeded, t, configuration, showSupportTypes }) => {
	return (
		<Form onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='enabled' component={Checkbox} label={t('PaymentMethod_Enabled')} normalize={v => !!v} />
			<Field name='hiddenForParents' component={Checkbox} label={t('PaymentMethod_HiddenForParents')} normalize={v => !!v} />
			{showSupportTypes && <Field name='enableOneOffPayments' component={Checkbox} label={t('PaymentMethod_EnableOneOffPayments')} normalize={v => !!v} />}
			{showSupportTypes && <Field name='enableRecurringPayments' component={Checkbox} label={t('PaymentMethod_EnableRecurringPayments')} normalize={v => !!v} />}
			{configuration}
		</Form>
	);
};

export default reduxForm({ form: 'paymentConfiguration', enableReinitialize: true })(SettingsForm);

export const selector = formValueSelector('paymentConfiguration');